import React, { useState } from 'react';
import { collection, addDoc, doc, deleteDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';
import { enviarCorreoNotificacion } from './emailService';

export default function AdminNotificaciones({
  edificioActual,
  propietarios,
  tituloNotificacion,
  setTituloNotificacion,
  mensajeNotificacion,
  setMensajeNotificacion,
  enviandoNotificacion,
  setEnviandoNotificacion,
  datosNotificaciones,
  db,
  obtenerRegistros
}) {
  // Estado local para el porcentaje de la barra de progreso (0 a 100)
  const [progresoEnvio, setProgresoEnvio] = useState(0);
  // Estado para el archivo adjunto (imagen o PDF)
  const [archivoComunicado, setArchivoComunicado] = useState(null);

  return (
    <div>
      <h2 style={{ marginTop: 0, color: '#1e293b' }}>Módulo de Comunicados y Notificaciones</h2>
      <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '20px' }}>
        Envía un mensaje o aviso general por correo electrónico y publícalo automáticamente en el portal del propietario con opción a adjuntar documentos para el edificio <strong>{edificioActual.nombre}</strong>.
      </p>

      <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '25px', marginBottom: '30px' }}>
        <h3 style={{ marginTop: 0, color: '#0f172a', fontSize: '1.1rem' }}>✍️ Redactar Nuevo Comunicado</h3>
        <form onSubmit={async (e) => {
          e.preventDefault();
          if (!tituloNotificacion.trim() || !mensajeNotificacion.trim()) {
            alert("Por favor completa el título y el mensaje del comunicado.");
            return;
          }

          if (propietarios.length === 0) {
            alert("⚠️ No hay propietarios registrados en este edificio.");
            return;
          }

          if (window.confirm(`¿Estás seguro de publicar y enviar este comunicado a todos los propietarios del edificio ${edificioActual.nombre}?`)) {
            try {
              setEnviandoNotificacion(true);
              setProgresoEnvio(0);

              // 1. Subir archivo adjunto a Firebase Storage si existe (para el portal de propietarios)
              let urlDescarga = '';
              if (archivoComunicado) {
                const storageRef = ref(storage, `comunicados_${edificioActual.id}/${Date.now()}_${archivoComunicado.name}`);
                await uploadBytes(storageRef, archivoComunicado);
                urlDescarga = await getDownloadURL(storageRef);
              }

              let enviados = 0;
              let sinCorreo = 0;
              const totalProps = propietarios.length;

              for (let i = 0; i < totalProps; i++) {
                let prop = propietarios[i];
                if (prop.correo && prop.correo.includes('@')) {
                  try {
                    await enviarCorreoNotificacion(
                      prop.correo,
                      prop.nombre,
                      tituloNotificacion.trim(),
                      mensajeNotificacion.trim(),
                      edificioActual.nombre
                    );
                    enviados++;
                  } catch (err) {
                    console.error(`Error enviando a ${prop.correo}:`, err);
                  }
                } else {
                  sinCorreo++;
                }

                // Calcular y actualizar el porcentaje de avance
                const porcentaje = Math.round(((i + 1) / totalProps) * 100);
                setProgresoEnvio(porcentaje);
              }

              // 2. Guardar el comunicado en la colección de Firebase con la URL del archivo
              const coleccionNotificaciones = `notificaciones_${edificioActual.id}`;
              await addDoc(collection(db, coleccionNotificaciones), {
                titulo: tituloNotificacion.trim(),
                mensaje: mensajeNotificacion.trim(),
                archivoUrl: urlDescarga || '',
                fechaEnvio: new Date().toLocaleDateString('es-PE'),
                fecha: new Date().toLocaleDateString('es-PE'), // Compatible con PropietarioComunicados
                horaEnvio: new Date().toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' }),
                totalEnviados: enviados
              });

              setTituloNotificacion('');
              setMensajeNotificacion('');
              setArchivoComunicado(null);
              await obtenerRegistros();

              alert(`✅ ¡Comunicado publicado en el portal y enviado con éxito!\n- Correos enviados: ${enviados}\n- Omitidos por falta de correo: ${sinCorreo}`);
            } catch (error) {
              console.error("Error general en envío de notificaciones:", error);
              alert("Ocurrió un error al procesar el comunicado.");
            } finally {
              setEnviandoNotificacion(false);
              setProgresoEnvio(0);
            }
          }
        }} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div>
            <label style={{ fontSize: '0.85rem', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#334155' }}>Título del Comunicado:</label>
            <input 
              type="text" 
              placeholder="Ej. Mantenimiento de bombas de agua / Asamblea general" 
              value={tituloNotificacion}
              onChange={e => setTituloNotificacion(e.target.value)}
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.95rem', boxSizing: 'border-box' }}
              required 
            />
          </div>

          <div>
            <label style={{ fontSize: '0.85rem', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#334155' }}>Mensaje o Detalle del Aviso:</label>
            <textarea 
              placeholder="Escribe aquí el contenido detallado del comunicado para los propietarios..." 
              value={mensajeNotificacion}
              onChange={e => setMensajeNotificacion(e.target.value)}
              rows="5"
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.95rem', boxSizing: 'border-box', fontFamily: 'inherit' }}
              required
            ></textarea>
          </div>

          <div>
            <label style={{ fontSize: '0.85rem', fontWeight: 'bold', display: 'block', marginBottom: '5px', color: '#334155' }}>
              📎 Adjuntar Imagen o PDF (Opcional, visible exclusivamente en el Portal de Propietarios):
            </label>
            <input 
              type="file" 
              accept="image/*,application/pdf"
              onChange={e => setArchivoComunicado(e.target.files[0])}
              style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', backgroundColor: 'white', boxSizing: 'border-box' }}
            />
            {archivoComunicado && (
              <p style={{ fontSize: '0.8rem', color: '#059669', margin: '5px 0 0 0', fontWeight: 'bold' }}>
                ✓ Archivo seleccionado: {archivoComunicado.name}
              </p>
            )}
          </div>

          {/* BARRA DE PROGRESO VISIBLE DURANTE EL ENVÍO */}
          {enviandoNotificacion && (
            <div style={{ backgroundColor: '#e2e8f0', borderRadius: '8px', overflow: 'hidden', width: '100%', height: '20px', position: 'relative', marginTop: '5px' }}>
              <div 
                style={{ 
                  width: `${progresoEnvio}%`, 
                  backgroundColor: '#0284c7', 
                  height: '100%', 
                  transition: 'width 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
              </div>
              <span style={{ position: 'absolute', width: '100%', textAlign: 'center', top: 0, left: 0, fontSize: '0.75rem', fontWeight: 'bold', color: progresoEnvio > 50 ? 'white' : '#1e293b', lineHeight: '20px' }}>
                Enviando correos... {progresoEnvio}%
              </span>
            </div>
          )}

          <button 
            type="submit" 
            disabled={enviandoNotificacion}
            style={{ backgroundColor: '#0284c7', color: 'white', border: 'none', padding: '12px 20px', borderRadius: '6px', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', alignSelf: 'flex-start' }}
          >
            {enviandoNotificacion ? `⏳ Procesando (${progresoEnvio}%)...` : '📢 Publicar y Enviar Comunicado Masivo'}
          </button>
        </form>
      </div>

      <h3 style={{ color: '#1e293b', marginBottom: '15px' }}>📁 Historial de Comunicados Enviados</h3>
      <div style={{ overflowX: 'auto', width: '100%', WebkitOverflowScrolling: 'touch' }}>
        <table className="tabla-propietarios">
          <thead>
            <tr>
              <th>Fecha / Hora</th>
              <th>Título del Comunicado</th>
              <th>Mensaje y Adjuntos</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {(!datosNotificaciones || datosNotificaciones.length === 0) ? (
              <tr><td colSpan="4" style={{ textAlign: 'center', padding: '25px', color: '#666' }}>No hay comunicados registrados en el historial de este edificio.</td></tr>
            ) : (
              datosNotificaciones.map(notif => (
                <tr key={notif.id}>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <strong>{notif.fechaEnvio}</strong><br/>
                    <span style={{ fontSize: '0.75rem', color: '#64748b' }}>{notif.horaEnvio}</span>
                  </td>
                  <td><strong>{notif.titulo}</strong></td>
                  <td style={{ maxWidth: '300px', fontSize: '0.9rem', color: '#334155' }}>
                    <div style={{ maxHeight: '80px', overflowY: 'auto', whiteSpace: 'pre-line', marginBottom: '5px' }}>{notif.mensaje}</div>
                    {notif.archivoUrl && (
                      <a href={notif.archivoUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem', color: '#0284c7', fontWeight: 'bold', textDecoration: 'none' }}>
                        📎 Ver archivo adjunto en portal ↗
                      </a>
                    )}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                      <button 
                        onClick={async () => {
                          if (propietarios.length === 0) {
                            alert("⚠️ No hay propietarios registrados en este edificio para reenviar.");
                            return;
                          }
                          if (window.confirm(`¿Deseas volver a enviar este comunicado ("${notif.titulo}") a todos los propietarios?`)) {
                            try {
                              let reenvios = 0;
                              for (let prop of propietarios) {
                                if (prop.correo && prop.correo.includes('@')) {
                                  await enviarCorreoNotificacion(
                                    prop.correo,
                                    prop.nombre,
                                    notif.titulo,
                                    notif.mensaje,
                                    edificioActual.nombre
                                  );
                                  reenvios++;
                                }
                              }
                              alert(`✅ ¡Reenvío masivo completado con éxito a ${reenvios} correos!`);
                            } catch (err) {
                              console.error("Error al reenviar:", err);
                              alert("Ocurrió un error al reenviar el comunicado.");
                            }
                          }
                        }} 
                        style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '6px 10px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold', cursor: 'pointer' }}
                        title="Reenviar a todos"
                      >
                        🔄 Reenviar
                      </button>

                      <button 
                        onClick={async () => {
                          if (window.confirm("⚠️ ¿Estás seguro de eliminar este comunicado del historial y del portal de propietarios?")) {
                            await deleteDoc(doc(db, `notificaciones_${edificioActual.id}`, notif.id));
                            await obtenerRegistros();
                            alert("¡Comunicado eliminado con éxito!");
                          }
                        }} 
                        style={{ backgroundColor: '#dc2626', color: 'white', border: 'none', padding: '6px 10px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 'bold', cursor: 'pointer' }}
                        title="Eliminar del historial"
                      >
                        🗑️ Borrar
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}